// SidenavTitle.js
import React from 'react';

const SidenavTitle = ({ title, subTitle }) => {
  return (
    <h1 className="font-titleFont text-xl font-semibold text-zinc-100 tracking-wide relative pb-4 mt-2 group">
      {/* Анимированная первая буква */}
      <span className="text-designColor transition-all duration-300 group-hover:text-white">
        {title}
      </span>
      {/* Основной текст */}
      <span className="transition-all duration-300 group-hover:text-zinc-300">
        {subTitle}
      </span>
      {/* Декоративный элемент с анимацией */}
      <span className="
        w-8 h-8
        bg-gradient-to-t
        from-designColor/30
        to-gray-600/10
        inline-block
        rounded-full
        absolute
        -left-3
        top-0
        -z-10
        transition-all
        duration-500
        group-hover:from-designColor/50
        group-hover:to-gray-600/30
        group-hover:scale-110
      "></span>
      {/* Подчеркивание */}
      <div className="
        absolute
        bottom-0
        left-0
        h-[1px]
        w-full
        bg-gradient-to-r
        from-transparent
        via-zinc-500
        to-transparent
      "></div>
    </h1>
  );
};

export default SidenavTitle;